import styled from "styled-components";

export const Container = styled.footer`
  width: 100%;
  height: 56px;
  background-color: #f3f3f3;

  position: fixed;
  bottom: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  figure {
    width: 119px;

    img {
      width: 100%;
    }
  }
`;
